import React, { useEffect, useState } from "react";
import {
  Link,
  Routes,
  Route,
  useLocation,
  useNavigate,
} from "react-router-dom";
import { MdCreateNewFolder } from "react-icons/md";
import App from "../App"; // Adjust path as per your actual structure
import Qualification from "../Qualification"; // Adjust path as per your actual structure
import FamilyDetails from "../FamilyDEtails"; // Adjust path as per your actual structure
import PreviousExperience from "../PrevousEx"; // Adjust path as per your actual structure
import AdditionalActivity from "../AditionalActivity";
import Emergency from "../Emergency";
import { MdPersonalInjury } from "react-icons/md";
import { MdOutlineCastForEducation } from "react-icons/md";
import { GiFamilyHouse } from "react-icons/gi";
import { MdOutlineMedicalInformation } from "react-icons/md";
import { MdContactEmergency } from "react-icons/md";
import { RiLogoutCircleFill } from "react-icons/ri";
import UploadForm from "./DocumentUpload";
import { HiDocumentArrowUp } from "react-icons/hi2";
import global from ".././assets/logo 1.png"
import FeedbackForm from "./Feedback";


const EnteryCandidatePortel = ({ userId, setUserId }) => {
  // alert(userId)
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const navigate = useNavigate();

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  console.log(userId, "fkjrjfwieji");

  const location = useLocation();

  const handleLogout = () => {
    localStorage.removeItem("token"); // Remove the token from local storage
    navigate("/SignInCandidate"); // Redirect to the login page
  };

  const getLogedInProfile = async (token) => {
    try {
      const response = await fetch(
        "  http://hr-onboarding-website-backend-LB-1197701009.us-east-1.elb.amazonaws.com:5000/getLogedInUser",
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            'Authorization': `Bearer ${token}`,
          },
        }
      );

      const responseData = await response.json();
      setUserId(responseData?.user?._id);
    } catch (error) {}
  };

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      getLogedInProfile(token);
    }
  }, []);

  return (
    <div className="h-screen">
      <div className="flex h-screen bg-gray-100">
        {/* Sidebar */}
        <div
          className={`fixed inset-y-0 left-0 bg-gray-800 text-white ${
            isSidebarOpen ? "w-64" : "w-20"
          } transform transition-all duration-300 ease-in-out z-50`}
        >
          <img src={global} className=""/>

          <div className="p-2 flex items-center justify-between">
            <h1
              className={`text-xl font-bold font-serif ${
                isSidebarOpen ? "block" : "hidden"
              }`}
            >
              OnBoarding Portal
            </h1>
            <button onClick={toggleSidebar} className="text-gray-400">
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M4 6h16M4 12h16m-7 6h7"
                ></path>
              </svg>
            </button>
          </div>

          <nav className="mt-5">
            <Link
              to=""
              className={`flex items-center py-2.5 px-4 rounded transition duration-200 ${
                location.pathname === "/EnteryCandidatePortel/PersonalDetails"
                  ? "bg-gray-700"
                  : "hover:bg-gray-700"
              }`}
            >
              <MdPersonalInjury className=" text-sm" />
              <span className={`ml-4 text-sm ${isSidebarOpen ? "block" : "hidden"}`}>
                Personal Details  
              </span>
            </Link>

            <Link
              to="/EnteryCandidatePortel/Qualifications"
              className={`flex items-center py-2.5 px-4 rounded transition duration-200 ${
                location.pathname === "/EnteryCandidatePortel/Qualifications"
                  ? "bg-gray-700"
                  : "hover:bg-gray-700"
              }`}
            >
              <MdOutlineCastForEducation className="text-sm" />
              <span className={`ml-4 text-sm ${isSidebarOpen ? "block" : "hidden"}`}>
                Qualifications
              </span>
            </Link>
            <Link
              to="/EnteryCandidatePortel/FamilyDetails"
              className={`flex items-center py-2.5 px-4 rounded transition duration-200 ${
                location.pathname === "/EnteryCandidatePortel/FamilyDetails"
                  ? "bg-gray-700"
                  : "hover:bg-gray-700"
              }`}
            >
              <GiFamilyHouse className="text-sm" />
              <span className={`ml-4 text-sm ${isSidebarOpen ? "block" : "hidden"}`}>
                Family Details
              </span>
            </Link>

            <Link
              to="/EnteryCandidatePortel/PreviousExperience"
              className={`flex items-center py-2.5 px-4 rounded transition duration-200 ${
                location.pathname ===
                "/EnteryCandidatePortel/PreviousExperience"
                  ? "bg-gray-700"
                  : "hover:bg-gray-700"
              }`}
            >
              <MdCreateNewFolder className="text-sm" />
              <span className={`ml-4 text-sm ${isSidebarOpen ? "block" : "hidden"}`}>
                Previous Experience
              </span>
            </Link>
            <Link
              to="/EnteryCandidatePortel/Additional-Information"
              className={`flex items-center py-2.5 px-4 rounded transition duration-200 ${
                location.pathname ===
                "/EnteryCandidatePortel/Additional-Information"
                  ? "bg-gray-700"
                  : "hover:bg-gray-700"
              }`}
            >
              <MdOutlineMedicalInformation className="text-sm" />
              <span className={`ml-4 text-sm ${isSidebarOpen ? "block" : "hidden"}`}>
                Additional Information
              </span>
            </Link>
            <Link
              to="/EnteryCandidatePortel/Emergency-Details"
              className={`flex items-center py-2.5 px-4 rounded transition duration-200 ${
                location.pathname === "/EnteryCandidatePortel/Emergency-Details"
                  ? "bg-gray-700"
                  : "hover:bg-gray-700"
              }`}
            >
              <MdContactEmergency className="text-sm" />
              <span className={`ml-4 text-sm ${isSidebarOpen ? "block" : "hidden"}`}>
                Emergency Details
              </span>
            </Link>
            <Link
              to="/EnteryCandidatePortel/document"
              className={`flex items-center py-2.5 px-4 rounded transition duration-200 ${
                location.pathname === "/EnteryCandidatePortel/document"
                  ? "bg-gray-700"
                  : "hover:bg-gray-700"
              }`}
            >
              <HiDocumentArrowUp className="text-sm" />
              <span className={`ml-4 text-sm ${isSidebarOpen ? "block" : "hidden"}`}>
                Upload Document
              </span>
            </Link>

            <Link
  to="/EnteryCandidatePortel/feedback"
  className={`flex items-center py-2.5 px-4 rounded transition duration-200 ${
    location.pathname === "/EnteryCandidatePortel/Feedback"
      ? "bg-gray-700"
      : "hover:bg-gray-700"
  }`}
>
  <MdOutlineMedicalInformation className="text-sm" />
  <span className={`ml-4 text-sm ${isSidebarOpen ? "block" : "hidden"}`}>
    Feedback
  </span>
</Link>


            <button
              onClick={handleLogout}
              className="flex items-center py-2.5 px-4 rounded transition duration-200 hover:bg-gray-700 w-full text-left"
            >
              <RiLogoutCircleFill className="text-sm" />
              <span className={`ml-4 text-sm ${isSidebarOpen ? "block" : "hidden"}`}>
                LogOut
              </span>
            </button>
          </nav>
        </div>

        {/* Main content */}
        <div
          className={`flex-1 flex flex-col transition-all duration-300 ease-in-out ${
            isSidebarOpen ? "ml-64" : "ml-20"
          }`}
        >

          <main className="flex-1 bg-gray-100 w-full ">
            <Routes>
              <Route index element={<App userId={userId} />} />
              <Route
                path="/Qualifications"
                element={<Qualification userId={userId} />}
              />
              <Route
                path="/FamilyDetails"
                element={<FamilyDetails userId={userId} />}
              />
              <Route
                path="/PreviousExperience"
                element={<PreviousExperience userId={userId} />}
              />
              <Route
                path="/Additional-Information"
                className=" mx-5 text-center"
                element={<AdditionalActivity userId={userId} />}
              />
              <Route
                path="/document"
                element={<UploadForm userId={userId} />}
              />
              <Route
                path="/Emergency-Details"
                element={<Emergency userId={userId} />}
              />
              <Route
                path="/feedback"
                element={<FeedbackForm userid={userId} />}
              />
            </Routes>
          </main>
        </div>
      </div>
    </div>
  );
};

export default EnteryCandidatePortel;
